<template>
  <div
    class="relative flex items-center w-full h-full min-w-[160px] min-h-[70px] rounded-xl"
    :class="[
      {
        'bg-[#e4fff4]': metric_clone.type == 'goal',
        'bg-[#f1f8ff]': metric_clone.type == 'plan',
        'bg-[#F4EBFF]': metric_clone.type == 'task',
        'bg-[#FFF8E7]': metric_clone.type == 'meeting',
        'bg-[#d0d8ff]': metric_clone.type == 'email',
        'bg-[#FFE3E5]': metric_clone.type == 'call',
        'bg-[#F1F8FF]': metric_clone.type == 'interaction'
      }
    ]">
    <div class="flex items-center justify-center bg-white rounded-full mx-2 w-10 h-10">
      <Star v-if="metric_clone.type == 'goal'" color="#27C884" class="w-5 h-5" />
      <FileSpreadsheet v-else-if="metric_clone.type == 'plan'" class="w-5 h-5 text-[#0A66C2]" />
      <ClipboardList v-else-if="metric_clone.type == 'task'" class="w-5 h-5 text-[#841FF4]" />
      <Users v-else-if="metric_clone.type == 'meeting'" class="w-5 h-5" />
      <Mail v-else-if="metric_clone.type == 'email'" class="w-5 h-5 text-[#1037FF]" />
      <Phone v-else-if="metric_clone.type == 'call'" class="w-5 h-5 text-[#FF636C]" />
      <Users v-else-if="metric_clone.type == 'interaction'" color="#1037FF" class="w-5 h-5" />
    </div>
    <div class="flex flex-col">
      <span class="font-bold text-[#46545C]">{{ metric_clone.count }} {{ metric_clone.title }}</span>
      <div class="flex items-center">
        <Play
          v-show="
            metric_clone.reference_name != 'company_interactions_total_count_rs' &&
              metric_clone.reference_name != 'company_meetings_total_count_rs' &&
              metric_clone.reference_name != 'company_emails_total_count_rs' &&
              metric_clone.reference_name != 'company_calls_total_count_rs'
          "
          stroke-width="0"
          fill="currentColor"
          class="cursor-pointer text-[#899399] w-4 h-4"
          :class="[$store.state.portfolio.ui_options?.language == 'ar' ? '' : 'rotate-180']"
          @click="leftClick()" />
        <Play
          v-show="
            metric_clone.reference_name != 'company_interactions_total_count_rs' &&
              metric_clone.reference_name != 'company_meetings_total_count_rs' &&
              metric_clone.reference_name != 'company_emails_total_count_rs' &&
              metric_clone.reference_name != 'company_calls_total_count_rs'
          "
          stroke-width="0"
          fill="currentColor"
          class="cursor-pointer text-[#899399] w-4 h-4"
          :class="[$store.state.portfolio.ui_options?.language == 'ar' ? 'rotate-180' : '']"
          @click="rightClick()" />
        <span class="text-sm text-[#899399]">{{ metric_clone.selected_option }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Mail, ClipboardList, FileSpreadsheet, Play, Phone, Star, Users } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Phone,
    Mail,
    ClipboardList,
    Play,
    FileSpreadsheet,
    Star,
    Users
  },
  props: {
    metric: {
      type: Object,
      required: true
    },
    dataSource: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      metric_clone: null
    }
  },
  created() {
    this.metric_clone = this.metric
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.REFRESH_ROLLUP_METRIC, ({ metric }) => {
        if (this.metric_clone.reference_name === metric.reference_name) {
          this.metric_clone["count"] = metric.value
        }
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.REFRESH_ROLLUP_METRIC)
      this.$emitter.off(ALL_EMITTERS.REFRESH_STANDARD_METRICS)
    },
    rightClick() {
      let index = this.metric_clone.options.findIndex((t) => t == this.metric_clone["selected_option"])
      if (index == this.metric_clone.options.length - 1) {
        this.metric_clone["selected_option"] = this.metric_clone.options[0]
        this.metric_clone["reference_name"] = this.metric_clone.references[0]
      } else {
        this.metric_clone["selected_option"] = this.metric_clone.options[index + 1]
        this.metric_clone["reference_name"] = this.metric_clone.references[index + 1]
      }
      this.$emitter.emit(ALL_EMITTERS.REFRESH_STANDARD_METRICS, {
        data_source: this.dataSource,
        reference_name: this.metric_clone.reference_name
      })
    },
    leftClick() {
      let index = this.metric_clone.options.findIndex((t) => t == this.metric_clone["selected_option"])
      if (index == 0) {
        this.metric_clone["selected_option"] = this.metric_clone.options[this.metric_clone.options.length - 1]
        this.metric_clone["reference_name"] = this.metric_clone.references[this.metric_clone.options.length - 1]
      } else {
        this.metric_clone["selected_option"] = this.metric_clone.options[index - 1]
        this.metric_clone["reference_name"] = this.metric_clone.references[index - 1]
      }
      this.$emitter.emit(ALL_EMITTERS.REFRESH_STANDARD_METRICS, {
        data_source: this.dataSource,
        reference_name: this.metric_clone.reference_name
      })
    }
  }
}
</script>
